// extracted by mini-css-extract-plugin
module.exports = {"uspContainer":"Usp_uspContainer__3CLcX","wrapper":"Usp_wrapper__d5Go2","accesibilityUspDisplay":"Usp_accesibilityUspDisplay__6KNw6","liWrapper":"Usp_liWrapper__IoSTS"};